import { SagaIterator } from "redux-saga"
import { call, put, fork, take, takeEvery, cancel, cancelled } from "redux-saga/effects"
import * as personalPlanningActions from "app/redux/personalPlanning/personalPlanning.actions"
import { createWebSocketConnectionForPersonalPlanning } from "app/webSockets/webSockets"
import { createSocketChannel, joinRoom, whenConnected } from "app/webSockets/channels"
import { Socket } from "socket.io-client"
import { PersonalPlanningChannelPayload } from "./personalPlanningChannel.reducer"
import * as actions from "./personalPlanningChannel.actions"

function* writeAndReadSocket(socket: Socket, payload: PersonalPlanningChannelPayload) {
  const readerChannel = yield call(createSocketChannel, socket)
  try {
    joinRoom(socket, payload)
    yield call(whenConnected, socket)
    yield put(actions.connectionTimeslotsChannelSuccess())
    while (true) {
      const result = yield take(readerChannel)
      yield put(personalPlanningActions.getPersonalPlanningTimeslotsSuccess(result))
    }
  } catch (error) {
    yield put(actions.connectionTimeslotsChannelFail(error))
  } finally {
    if (yield cancelled()) {
      socket.disconnect()
      readerChannel.close()
      yield put(actions.disconnectTimeslotsChannelSuccess())
    } else {
      yield put(actions.disconnectTimeslotsChannelFail(new Error("disconnected")))
    }
  }
}

function* listen(action: actions.ConnectTimeslotsChannelAction) {
  const socket = yield call(createWebSocketConnectionForPersonalPlanning)
  const w = yield fork(writeAndReadSocket, socket!, action.payload)

  yield take(actions.Types.DISCONNECT)
  yield cancel(w)
}

export default function* timeslotsChannelSaga(): SagaIterator {
  yield takeEvery([actions.Types.CONNECT], listen)
}
